module.exports = __webpack_public_path__ + "static/indies-e3cc12301440a943d417fcdc52136788.jpg";